import { ProductContext } from '../../../../../types/ProductContext';
import { OfferModel } from '../../../model/OfferModel';
import { OfferState } from '../../../model/OfferState';

export const isAdminReopenableOffer = (offer: OfferModel) =>
    offer.type === ProductContext.LUBES && offer.state === OfferState.ENQUIRY_DECLINED;
